import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

export enum SoundTrack {
    GAME_SOUNDTRACK,
    MENUS,
    PENALTY,
    EXTRA_TIME
}
// audiosprite --e "mp3" --o audio_effects *.mp3

export class AudioManager {

    private static _instance: AudioManager = null;

    public musicOnButton: Phaser.Button;
    public musicOffButton: Phaser.Button;
    public fxOnButton: Phaser.Button;
    public fxOffButton: Phaser.Button;

    private _isMusicMuted: boolean;
    private _areEffectsMuted: boolean;
    private musicsArray: Phaser.Sound[];

    private musicPlayingIndex: number;
    private volume: number;
    private audioSprite: Phaser.AudioSprite;
    private effectPlayingKey: string;
    private game: Phaser.Game;

    public static getInstance(): AudioManager {

        if (AudioManager._instance === null) {
            AudioManager._instance = new AudioManager();
        }

        return AudioManager._instance;
    }

    constructor() {

        if (AudioManager._instance) {
            throw new Error("Error: Instantiation failed: Use AudioManager.getInstance() instead of new.");
        }

        this.musicPlayingIndex = null;

        this.musicOnButton = null;
        this.musicOffButton = null;
        this.fxOnButton = null;
        this.fxOffButton = null;

        this.volume = 1;

        this.musicsArray = new Array();

        AudioManager._instance = this;
    }

    public init(game: Phaser.Game): void {

        this.game = game;

        if (GameConstants.DEVELOPMENT) {
            this._isMusicMuted = true;
            this._areEffectsMuted = true;
        } else {
            this._isMusicMuted = GameVars.gameData.audioState[0];
            this._areEffectsMuted = GameVars.gameData.audioState[1];
        }

        this.musicsArray[SoundTrack.GAME_SOUNDTRACK] = this.game.add.audio("soundtrack", 1, true);
        this.musicsArray[SoundTrack.MENUS] = this.game.add.audio("musica_menus", 1, true);
        this.musicsArray[SoundTrack.PENALTY] = this.game.add.audio("musica_penalty", 1, true);
        this.musicsArray[SoundTrack.EXTRA_TIME] = this.game.add.audio("musica_prorroga", 1, true);

        // audiosprites
        this.audioSprite = this.game.add.audioSprite("audio_effects");
    }

    public playMusic(musicPlayingIndex: number): void {

        if (musicPlayingIndex === null) {
            return;
        }

        this.musicPlayingIndex = musicPlayingIndex;

        if (!this._isMusicMuted) {

            const music = this.musicsArray[this.musicPlayingIndex];

            if (music != null && !music.isPlaying) {
                music.play("", 0, this.volume, true, true);
            }
        }
    }

    public stopMusic(musicPlayingIndex: number): void {

        if (musicPlayingIndex === null) {
            return;
        }

        const music = this.musicsArray[musicPlayingIndex];

        if (music != null && music.isPlaying) {
            music.stop();
        }
    }

    public setVolumePlayingMusic(volume: number): void {

        this.volume = volume;

        const music = this.musicsArray[this.musicPlayingIndex];

        if (music) {
            music.volume = this.volume;
        }
    }

    public playEffect(key: string): void {

        if (key === null || this._areEffectsMuted) {
            return;
        }

        this.effectPlayingKey = key;
        this.audioSprite.play(key, this.volume);
    }

    public setAudioState(isOff: boolean): void {

        if (isOff) {

            this.stopMusic(this.musicPlayingIndex);
            this.stopEffect(this.effectPlayingKey);

            this.isMusicMuted = true;
            this.areEffectsMuted = true;

            if (this.musicOnButton) {
                this.musicOnButton.visible = false;
            }

            if (this.musicOffButton) {
                this.musicOffButton.visible = true;
            }

            if (this.fxOnButton) {
                this.fxOnButton.visible = false;
            }

            if (this.fxOffButton) {
                this.fxOffButton.visible = true;
            }

        } else {

            this.isMusicMuted = false;
            this.areEffectsMuted = false;

            this.playMusic(this.musicPlayingIndex);

            if (this.musicOnButton) {
                this.musicOnButton.visible = true;
            }

            if (this.musicOffButton) {
                this.musicOffButton.visible = false;
            }

            if (this.fxOnButton) {
                this.fxOnButton.visible = true;
            }

            if (this.fxOffButton) {
                this.fxOffButton.visible = false;
            }
        }

        GameVars.gameData.audioState = [this._isMusicMuted, this._areEffectsMuted];
    }

    public stopEffect(key: string): void {

        if (key === null) {
            return;
        }

        this.audioSprite.stop(key);
    }

    public muteAudio(): void {
        this.setAudioState(true);
    }

    public unmuteAudio(): void {
        this.setAudioState(false);
    }

    public get isMusicMuted(): boolean {

        return this._isMusicMuted;
    }

    public set isMusicMuted(value: boolean) {

        this._isMusicMuted = value;

        if (this._isMusicMuted) {
            this.pauseMusic();
        } else {
            this.resumeMusic();
        }

        GameVars.gameData.audioState = [this._isMusicMuted, this._areEffectsMuted];

        GameManager.writeGameStorage();
    }

    public get areEffectsMuted(): boolean {

        return this._areEffectsMuted;
    }

    public set areEffectsMuted(value: boolean) {

        this._areEffectsMuted = value;

        if (this._areEffectsMuted) {
            this._areEffectsMuted = true;

            this.stopEffect(this.effectPlayingKey);

        } else {
            this._areEffectsMuted = false;
        }

        GameVars.gameData.audioState = [this._isMusicMuted, this._areEffectsMuted];

        GameManager.writeGameStorage();
    }

    private pauseMusic(): void {

        var music: Phaser.Sound = this.musicsArray[this.musicPlayingIndex];

        if (music) {
            music.pause();
        }
    }

    private resumeMusic(): void {

        var music: Phaser.Sound = this.musicsArray[this.musicPlayingIndex];

        if (music == null) {
            return;

        }
        if (music.paused) {
            music.resume();
        } else {
            music.play("", 0, this.volume, true, true);
        }
    }
}
